import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

export const ScrollReveal = ({ children, delay = 0, direction = "up", className = "" }) => {
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  const getY = () => {
    if (direction === "up") return 40;
    if (direction === "down") return -40;
    return 0;
  };

  const getX = () => {
    if (direction === "left") return 40;
    if (direction === "right") return -40;
    return 0;
  };

  const variants = {
    hidden: {
      opacity: 0,
      y: getY(),
      x: getX(),
    },
    visible: {
      opacity: 1,
      y: 0,
      x: 0,
    },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants}
      transition={{ duration: 0.6, delay, ease: [0.25, 0.46, 0.45, 0.94] }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
